import { styled } from "@mui/system";
import { Card, cardClasses, cardContentClasses } from "@mui/material";

const CardWizard = styled(Card)(({ theme }) => ({
	[`& .${cardContentClasses.root}`]: {
		padding: "16px",
	},
	[`& .${cardContentClasses.root}:last-child`]: {
		paddingBottom: "16px",
	},
	[theme.breakpoints.down("md")]: {
		p: 0,
		borderRadius: 0,
		border: "none",
		boxShadow: "none",
		[`& .${cardContentClasses.root}`]: {
			padding: 0,
		},
		[`& .${cardContentClasses.root}:last-child`]: {
			padding: 0,
		},
	},
}));

export default CardWizard;
